// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-overdue.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-overdue/flight-plan-overdue.js';

mount([g0]);
